import { useMemo } from 'react';

import type { NftAttribute } from '@/ui/types';
import PropertiesTable from './properties-table.js';

interface AttributesTableProps {
  attributes: NftAttribute[];
}

const AttributesTable = ({ attributes = [] }: AttributesTableProps) => {
  const data = useMemo(
    () =>
      attributes.reduce(
        (accumulator, attribute) => {
          accumulator[attribute.trait] = attribute.value;
          return accumulator;
        },
        {} as { [trait: string]: string },
      ),
    [attributes],
  );

  return <PropertiesTable data={data} />;
};

export default AttributesTable;
